import { auth } from "../firebase";
import { AuthUser, Pass } from "../model/Auth";
import { Result } from "../model/Result";
import axiosCilent from "./axiosClient";
import jwtApi from "./Jwt.api";

//管理者系は Firebase auth に登録するため authApi
const authApi = {
  requestCreateStaff: async ( staff: AuthUser & Pass, tenantId: string )
    : Promise<Result> => {
    try {
      const response = await axiosCilent.post(`createStaff/${tenantId}`, staff);
      return response.data;
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestUpdateStaff: async ( staff: AuthUser & Pass, tenantId: string )
    : Promise<Result> => {
    try {
      const response = await axiosCilent.post(`updateStaff/${tenantId}`, staff);
      return response.data;      
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestDeleteStaff: async( staff: AuthUser, tenantId: string )
    : Promise<Result> => {
    try {
      const response = await axiosCilent.post(`deleteStaff/${tenantId}`, staff);
      return response.data;
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestGetStaff: async (tenantId: string)
    : Promise<Result> => {
    try {
      const response = await axiosCilent.post(
        `getStaffList/${tenantId}`, {}, {
          timeout: 0
        });
          return response.data;
    } catch (error) {
      return {success: false, data: error};
    }
  },

  registerPageRequestSendEmail: async (email: string)
    : Promise<Result> => {
    try {
      const response = await axiosCilent.post(`sendEmail`, {email},
      {
        headers: {
          'Authorization': `${sessionStorage.getItem("jwt")}`
        }            
      });
      return response.data;
    } catch (err: any) {
      console.error(err);
      return {success: false, data: err}
    }
  },
  requestTenantSendEmail: async (tenantId: string, email: string)
    : Promise<Result> => {
    try {
      const response = await axiosCilent.post(`tenantSendEmail/${tenantId}`, {email});
      return response.data;
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestSendEmailGeneral: async (text: string, subject: string, toAddress: string)
    : Promise<Result> => {
    try {
      const response = await axiosCilent.post(`sendEmailGeneral/${text}/${subject}`, {toAddress});
      return response.data;
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestSendPasswordResetEmail: async (email: string)
    : Promise<Result> => {
    try {
      const response = await axiosCilent.post(`sendPasswordResetEmail`, {email});
      return response.data;
    } catch (error) {
      return {success: false, data: error};
    }
  },
  requestTenantSendPasswordResetEmail: async (tenantId: string, email: string)
    : Promise<Result> => {
    try {
      const response = await axiosCilent.post(`tenantSendPasswordResetEmail/${tenantId}`, {email});
      return response.data;
    } catch (error) {
      return {success: false, data: error};
    }
  },

  /**
   * 団体管理者情報を取得する
   * 
   * @param tenantId 
   * @param userId 
   * @returns 
   */
  requestGetStaffInfo: async (tenantId: string, userId: string) : Promise<Result> => {
    try {
      const requestData = { userId: userId };
      const response = await axiosCilent.post(`getStaffInfo/${tenantId}`, requestData);
      return response.data;

    } catch (error) {
      return {success: false, data: error};
    }
  },
};

export default authApi;
